import { Flex, Stack, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {
  PageContainer,
  PageFooter,
  PageHeader,
  SimpleStepDots,
  StepProps,
} from '../../../shared_components';
import { FC, useState } from 'react';
import classes from '../../../app.module.css';

export const StepInfo: FC<StepProps> = ({ forward, back }) => {
  const { t } = useTranslation(['payment', 'common']);
  const [mute, setMute] = useState(true);

  function toggleSound() {
    if (mute) setMute(false);
    else setMute(true);
  }

  return (
    <PageContainer>
      <Flex direction={'column'} justify={'space-between'} h={'100%'}>
        <Stack classNames={{ root: classes.footerPadding }}>
          <PageHeader
            title={t('qr_code_info_title')}
            message={t('qr_code_info_message')}
            topElement={<SimpleStepDots step={3} max={3} />}
          />

          <video
            style={{ borderRadius: 'var(--mantine-radius-xl)' }}
            autoPlay
            playsInline
            muted={mute}
            loop
            id="qrVideo"
          >
            <source
              src={'../../../../assets/videos/test.mp4'}
              type={'video/mp4'}
            />
            Your browser does not support the html video tag.
          </video>
          <Button style={{ display: 'none' }} onClick={toggleSound}>
            {mute ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </Button>
        </Stack>
        <PageFooter
          hideBack={true}
          buttonText={t('understood')}
          buttonIcon={<CheckIcon />}
          rightOnClick={forward}
        />
      </Flex>
    </PageContainer>
  );
};
